


































































































































































































































































































































































































































































































































































import { mapActions, mapGetters } from 'vuex';
import { cloneDeep, isEqual } from 'lodash';
import moment from 'moment';
import mixins from '@/utils/mixins';
import { AxiosError } from 'axios';

import {
  IPaymentRequisition,
  PaymentRequisition,
  PaymentRequisitionLine,
  PaymentRequisitionFieldError,
  Vendor,
  PaymentRequisitionSupplierAddress,
  IPaymentRequisitionSupplierAddressData,
  IPaymentRequisitionSupplierAddress,
  IPaymentRequisitionSupplierContactData,
  PaymentRequisitionSupplierContact,
  IPaymentRequisitionSupplierContact,
  PaymentRequisitionSupplier,
  IPaymentRequisitionAttachment,
  Currency,
  Country,
  PaymentRequisitionPaymentType
} from '@/models';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';
import { diffDeep, scrollToBottomOfHtmlElement } from '@/utils/helpers';

import PaymentRequisitionDetailFormLineCard from '@/components/payment-requisition/PaymentRequisitionDetailFormLineCard.vue';
import VendorSearch from '@/components/vendor/VendorSearch.vue';
import CountryPicker from '../common/CountryPicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import auth from '@/mixins/auth';
import ALDialog from '../core/Dialog/ALDialog.vue';
import PaymentRequisitionAttachmentListItem from './PaymentRequisitionAttachmentListItem.vue';
import PaymentRequisitionStatusDisplay from '../requisition-common/PaymentRequisitionStatusDisplay.vue';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'PaymentRequisitionDetailFormDialog',

    components: {
      PaymentRequisitionDetailFormLineCard,
      VendorSearch,
      CountryPicker,
      DragDropFileInput,
      ConfirmationDialog,
      ErrorAlert,
      ALDialog,
      PaymentRequisitionAttachmentListItem,
      PaymentRequisitionStatusDisplay
    },

    data: () => ({
      paymentRequisitionFormValid: true,
      loading: false,
      isEdit: false,
      dialog: false,
      currencyLoading: false,
      departmentLoading: false,
      glAccountsLoading: false,
      dateMenu: false,
      isDragOver: false,
      confirmDialog: false,

      paymentRequisitionOriginalCopy: null as null | IPaymentRequisition,
      paymentRequisition: null as null | IPaymentRequisition,
      fieldError: new PaymentRequisitionFieldError(),

      paymentOptions: [
        { type: 'Cash', payment: PaymentRequisitionPaymentType.CASH },
        { type: 'Card', payment: PaymentRequisitionPaymentType.CARD },
        { type: 'Cheque', payment: PaymentRequisitionPaymentType.CHEQUE },
        { type: 'Wire', payment: PaymentRequisitionPaymentType.WIRE }
      ],

      paymentRequisitionSupplierName: '',
      errorMessage: '',
      errorMessageDetail: ''
    }),

    mounted() {
      // fetch all currencies
      this.currencyLoading = true;
      this.fetchCurrencies()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          this.fieldError.currency.push('Error occurred getting currencies');
        })
        .finally(() => (this.currencyLoading = false));

      // fetch all departments
      this.departmentLoading = true;
      this.fetchDepartments()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.departmentLoading = false));

      // fetch all GL Accounts
      this.glAccountsLoading = true;
      this.fetchGLAccounts()
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.glAccountsLoading = false));
    },

    computed: {
      ...mapGetters({
        accounts: 'accounting/getGLAccounts',
        currencies: 'currencyNew/getCurrencies',
        getCurrencyByCode: 'currencyNew/getCurrencyByCode',
        departments: 'department/getDepartments',
        lastCreatedPaymentRequisitionId:
          'paymentRequisition/getLastCreatedPaymentRequisitionId'
      }),

      errorOccurred(): boolean {
        return this.errorMessage.length > 0;
      },

      disableAddressFields(): boolean {
        return this.paymentRequisitionSupplierName.length == 0;
      },

      disableCurrencyField(): boolean {
        return !!this.paymentRequisition!.supplier!.vendor_code;
      }
    },

    watch: {
      'paymentRequisition.supplier.vendor_code': {
        handler(value) {
          if (value) {
            //clear supplier name field if a vendor is selected
            this.paymentRequisitionSupplierName = '';
          }
        }
      },
      paymentRequisitionSupplierName: {
        handler(value) {
          if (value && this.paymentRequisition!.supplier!.vendor_code) {
            //clear selected supplier search field if a vendor is manually inputted
            this.paymentRequisition!.supplier!.vendor_code! = '';
            this.clearRequitionSupplierAddress();
          }
        }
      }
    },

    methods: {
      ...mapActions({
        fetchGLAccounts: 'accounting/fetchGLAccounts',
        fetchCurrencies: 'currencyNew/fetchCurrencies',
        fetchDepartments: 'department/fetchDepartments',
        createPaymentRequisition: 'paymentRequisition/createPaymentRequisition',
        updatePaymentRequisition: 'paymentRequisition/updatePaymentRequisition',
        deletePaymentRequisitionAttachment:
          'paymentRequisition/deletePaymentRequisitionAttachment'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(
        paymentRequisition: IPaymentRequisition = new PaymentRequisition(),
        isEdit = false
      ) {
        this.paymentRequisitionOriginalCopy = paymentRequisition;
        this.paymentRequisition = cloneDeep(
          this.paymentRequisitionOriginalCopy
        );

        if (!this.paymentRequisition!.supplier!.vendor_code) {
          this.paymentRequisitionSupplierName = this.paymentRequisition.supplier!.name!;
        }

        this.isEdit = isEdit;
        this.clearAllErrors();
        this.dialog = true;

        this.resetFormValidation();
      },

      close() {
        if (
          !isEqual(
            this.paymentRequisition,
            this.paymentRequisitionOriginalCopy
          ) &&
          this.isEdit
        ) {
          this.confirmDialog = true;
        } else {
          this.closeDialog();
        }
      },

      formatDate(date: string): string {
        return date ? moment(date).format('MMMM D YYYY') : '';
      },

      allowedDates: (val: string) => {
        return moment(val).isSameOrAfter(new Date(), 'day');
      },

      clearRequitionSupplierAddress() {
        this.paymentRequisition!.supplier!.address = new PaymentRequisitionSupplierAddress();
      },

      setRequitionSupplierAddress(vendor: Vendor): void {
        if (vendor) {
          this.clearAllErrors();

          const vendorSupplierContactData: IPaymentRequisitionSupplierContactData = {
            name: vendor.contact,
            email: vendor?.email,
            phone: vendor?.phone
          };

          const vendorSupplierAddressData: IPaymentRequisitionSupplierAddressData = {
            address1: vendor.address1,
            address2: vendor.address2,
            city: vendor.city,
            region: vendor.region,
            postal_code: vendor.postal_code,
            country: (vendor.country as Country).code
          };

          const supplierAddress: IPaymentRequisitionSupplierAddress = new PaymentRequisitionSupplierAddress(
            vendorSupplierAddressData
          );
          const supplierContact: IPaymentRequisitionSupplierContact = new PaymentRequisitionSupplierContact(
            vendorSupplierContactData
          );

          const supplier = new PaymentRequisitionSupplier({
            name: vendor.name,
            vendor_code: vendor.id,
            address:
              supplierAddress ?? this.paymentRequisition?.supplier?.address,
            contact: supplierContact ?? new PaymentRequisitionSupplierContact()
          });

          this.paymentRequisition!.supplier = supplier;

          const currency: Currency = this.getCurrencyByCode(vendor.currency);
          if (currency) {
            this.paymentRequisition!.currency = currency.id;
          }
        }
      },

      async addPaymentRequisitionAttachments(file: File | File[]) {
        this.clearAllErrors();
        const fileList = file && Array.isArray(file) ? file : [file];
        fileList.forEach(file => {
          this.paymentRequisition?.attachFile(file);
        });
        this.$nextTick(() => {
          scrollToBottomOfHtmlElement('#scrollableAttachmentList');
        });
      },

      async removePaymentRequisitionAttachment(
        attachment: IPaymentRequisitionAttachment
      ) {
        this.clearAllErrors();
        if (attachment.id) {
          await this.deletePaymentRequisitionAttachment({
            paymentRequisitionId: this.paymentRequisition?.id,
            attachmentId: attachment.id
          }).catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          });
        }
        this.paymentRequisition?.detachFile(attachment.file as File);
      },

      addLine(): void {
        this.paymentRequisition!.addLine(new PaymentRequisitionLine());
      },

      deleteLine(line: number): void {
        const index = line - 1;
        this.paymentRequisition!.removeLine(index);
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      clearSupplierContactErrors(): void {
        if (this.fieldError.supplier && this.fieldError.supplier.contact) {
          this.fieldError.supplier.contact.clearErrors();
        }
      },

      clearFinancePaymentRequisitiionDetails() {
        this.paymentRequisition!.note = '';
        this.paymentRequisition!.reason = '';
      },

      closeDialog() {
        this.closeConfirmDialog();
        this.dialog = false;
      },

      closeConfirmDialog() {
        this.confirmDialog = false;
      },

      async savePaymentRequisition(): Promise<void> {
        if (this.validateForm()) {
          this.confirmDialog = false;

          this.clearAllErrors();

          this.loading = true;

          if (this.paymentRequisitionSupplierName) {
            this.paymentRequisition!.supplier!.name! = this.paymentRequisitionSupplierName;
          }

          if (!this.paymentRequisition?.is_provide_payment_detail) {
            this.clearFinancePaymentRequisitiionDetails();
          }

          try {
            if (this.isEdit) {
              const paymentRequisitionDelta = diffDeep(
                this.paymentRequisition,
                this.paymentRequisitionOriginalCopy,
                true
              );
              paymentRequisitionDelta!.id = this.paymentRequisition!.id;
              await this.updatePaymentRequisition(paymentRequisitionDelta);
            } else {
              await this.createPaymentRequisition(this.paymentRequisition);

              this.$emit(
                'created:payment-requisition',
                this.lastCreatedPaymentRequisitionId
              );
            }

            // emit success
            this.$emit('success');
            // bypass close dialog checks
            this.dialog = false;
          } catch (err) {
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessage = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                PaymentRequisitionFieldError.isPaymentRequisitionFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new PaymentRequisitionFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          } finally {
            this.loading = false;
          }
        }
      }
    }
  });
